/**
 * Resolve storefront display prices from variant/product API data.
 * When offer is active: list price struck + offer price bold (sale price hidden).
 */
export function getDisplayPrices(item) {
  const salePrice = item?.price?.sale_price ?? item?.salePrice ?? item?.lowestPrice ?? item?.price ?? 0;
  const listPrice = item?.price?.cost_price ?? item?.costPrice ?? item?.originalPrice ?? 0;
  const offerPricing = item?.offerPricing ?? null;
  const displayPrice = item?.displayPrice ?? (offerPricing?.offerPrice ?? salePrice);

  if (offerPricing?.offerPrice != null) {
    return {
      displayPrice: offerPricing.offerPrice,
      strikePrice: listPrice > offerPricing.offerPrice ? listPrice : null,
      showSalePrice: false,
      hasOffer: true,
      offer: offerPricing.offer,
    };
  }

  return {
    displayPrice: salePrice,
    strikePrice: listPrice > salePrice ? listPrice : null,
    showSalePrice: true,
    hasOffer: false,
    offer: null,
  };
}

export function formatKES(amount) {
  if (amount == null || Number.isNaN(amount)) return 'KSh 0';
  return `KSh ${Number(amount).toLocaleString()}`;
}

/** Only show when product.vatMode === 'inclusive'. Never for exclusive/zero. */
export function shouldShowIncVatLabel(vatMode) {
  return vatMode === 'inclusive';
}
